import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import Logger from '../utils/logger';
import { ProjectEstimationResponse } from '../types/api';

interface UseProjectCostProps {
  cpu: number;
  ram: number;
  storage: number;
}

interface ProjectCostState {
  estimation: ProjectEstimationResponse | null;
  loading: boolean;
  error: string | null;
}

export const useProjectCost = ({ cpu, ram, storage }: UseProjectCostProps) => {
  const [state, setState] = useState<ProjectCostState>({
    estimation: null,
    loading: false,
    error: null
  });

  useEffect(() => {
    if (cpu > 0 && ram > 0 && storage > 0) {
      calculateCost();
    }
  }, [cpu, ram, storage]); // calculateCost is defined in the component, safe to exclude

  const calculateCost = async () => {
    try {
      setState(prev => ({ ...prev, loading: true, error: null }));

      const estimation = await apiService.estimateProjectCost(cpu, ram, storage);

      setState(prev => ({
        ...prev,
        estimation,
        loading: false
      }));
    } catch (error: unknown) {
      Logger.error('Error calculating project cost:', error);
      const apiError = error as { response?: { data?: { detail?: string } } };
      setState(prev => ({
        ...prev,
        error: apiError.response?.data?.detail || 'Erreur de calcul',
        loading: false
      }));
    }
  };

  return {
    ...state,
    refetch: calculateCost
  };
};

export default useProjectCost;